class SkipperPredictiveSearch {
  constructor(form) {
    this.form = form;
    this.input = form.querySelector('.skipper-cat-nav__search-input');
    this.dropdown = null;
    this.debounceTimer = null;
    this.activeIndex = -1;

    this.input.addEventListener('input', () => this.onInput());
    this.input.addEventListener('keydown', (e) => this.onKeydown(e));
    this.input.addEventListener('focus', () => {
      if (this.input.value.trim().length >= 2) this.search(this.input.value.trim());
    });
    document.addEventListener('click', (e) => {
      if (!this.form.contains(e.target) && !this.dropdown?.contains(e.target)) {
        this.closeDropdown();
      }
    });
  }

  onInput() {
    clearTimeout(this.debounceTimer);
    const q = this.input.value.trim();
    if (q.length < 2) { this.closeDropdown(); return; }
    this.debounceTimer = setTimeout(() => this.search(q), 220);
  }

  onKeydown(e) {
    if (!this.dropdown) return;
    const items = this.dropdown.querySelectorAll('[data-ps-item]');
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      this.activeIndex = Math.min(this.activeIndex + 1, items.length - 1);
      this.updateActive(items);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      this.activeIndex = Math.max(this.activeIndex - 1, -1);
      this.updateActive(items);
    } else if (e.key === 'Enter' && this.activeIndex >= 0) {
      e.preventDefault();
      window.location.href = items[this.activeIndex].href;
    } else if (e.key === 'Escape') {
      this.closeDropdown();
      this.input.blur();
    }
  }

  updateActive(items) {
    items.forEach((item, i) => item.classList.toggle('skipper-ps__item--active', i === this.activeIndex));
  }

  async search(q) {
    try {
      const res = await fetch(
        `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`
      );
      if (!res.ok) return;
      const data = await res.json();
      this.showDropdown(q, data.resources?.results?.products || []);
    } catch (e) {
      // form submit still works on enter
    }
  }

  imgSrc(url) {
    if (!url) return '';
    return url.includes('?') ? `${url}&width=80` : `${url}?width=80`;
  }

  showDropdown(q, products) {
    this.closeDropdown();
    this.activeIndex = -1;

    const el = document.createElement('div');
    el.className = 'skipper-ps-dropdown';
    el.setAttribute('role', 'listbox');

    if (products.length === 0) {
      el.innerHTML = `<p class="skipper-ps__empty">No results for "<strong>${this.esc(q)}</strong>"</p>`;
    } else {
      const rows = products.map(p => {
        const img = this.imgSrc(p.featured_image?.url || p.image?.src || '');
        const price = p.price ? `$${(parseInt(p.price, 10) / 100).toFixed(2)}` : '';
        return `
          <a href="${p.url}" class="skipper-ps__item" data-ps-item role="option">
            <div class="skipper-ps__img">
              ${img ? `<img src="${img}" alt="" width="40" height="40" loading="lazy">` : '<div class="skipper-ps__img-blank"></div>'}
            </div>
            <div class="skipper-ps__info">
              <span class="skipper-ps__name">${this.esc(p.title)}</span>
              ${price ? `<span class="skipper-ps__price">${price}</span>` : ''}
            </div>
            <svg class="skipper-ps__arrow" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
          </a>`;
      }).join('');

      el.innerHTML = `
        <div class="skipper-ps__list">${rows}</div>
        <a href="/search?q=${encodeURIComponent(q)}&type=product" class="skipper-ps__view-all" data-ps-item>
          View all results for "<strong>${this.esc(q)}</strong>"
          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
        </a>`;
    }

    document.body.appendChild(el);
    this.dropdown = el;
    this.positionDropdown();

    this._onScroll = () => this.positionDropdown();
    this._onResize = () => this.positionDropdown();
    window.addEventListener('scroll', this._onScroll, { passive: true });
    window.addEventListener('resize', this._onResize, { passive: true });

    el.querySelectorAll('[data-ps-item]').forEach((item, i) => {
      item.addEventListener('mouseenter', () => {
        this.activeIndex = i;
        this.updateActive(el.querySelectorAll('[data-ps-item]'));
      });
    });
  }

  positionDropdown() {
    if (!this.dropdown) return;
    const rect = this.form.getBoundingClientRect();
    Object.assign(this.dropdown.style, {
      position: 'fixed',
      top: `${rect.bottom}px`,
      left: `${rect.left}px`,
      width: `${Math.max(rect.width, 300)}px`,
      zIndex: '10000',
    });
  }

  closeDropdown() {
    if (this.dropdown) {
      this.dropdown.remove();
      this.dropdown = null;
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onResize);
    }
  }

  esc(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.skipper-cat-nav__search').forEach(form => {
    new SkipperPredictiveSearch(form);
  });
});
